import { useState } from "react";
import { Container, Card, Form, Button, Navbar } from "react-bootstrap";
import { FiLock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import api from "../utils/helper";

const SendOtp = () => {
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const [phoneNumber, setPhoneNumber] = useState("");
  const navigate = useNavigate();

  const countryList = [
    { code: "+91", name: "India" },
    // { code: "+92", name: "United States" },
    // { code: "+93", name: "United Kingdom" },
    // { code: "+94", name: "Australia" },
    // { code: "+95", name: "China" },
    // { code: "+96", name: "Japan" },
  ];

  const sendOtpMutation = useMutation(
    (otpData) => api.post("/auth/send-otp", otpData),
    {
      onSuccess: (response) => {
        console.log("OTP sent successfully:", response.data);
        navigate("/otp-verification", {
          state: {
            phoneNumber: `${selectedCountry}${phoneNumber}`,
          },
        });
      },
      onError: (error) => {
        console.error("Error sending OTP:", error);
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Failed to send OTP. Please try again.";
        console.log(errorMessage);
      },
    }
  );

  const handleGetOTP = (e) => {
    e.preventDefault();

    if (!phoneNumber.trim()) {
      alert("Please enter a valid phone number");
      return;
    }

    const otpData = {
      type: "sms",
      receiver: `${selectedCountry}${phoneNumber}`,
      // receiver: `${phoneNumber}`,
      // countryCode: `${selectedCountry}`,
    };

    sendOtpMutation.mutate(otpData);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <>
      <Navbar variant="dark" expand={false} className="py-2 bgNav sticky-top">
        <Container fluid className="px-3">
          <div className="d-flex align-items-center w-100 justify-content-md-start justify-content-center">
            {/* Logo */}
            <Navbar.Brand href="#home">
              <img
                src="/images/Group 1.png"
                height="40"
                className="d-inline-block align-top"
                alt="HyTech Didactic Logo"
              />
            </Navbar.Brand>
          </div>
        </Container>
      </Navbar>
      <Container
        fluid
        className="d-flex justify-content-center align-items-center pt-5"
      >
        <Card className="phone-modal">
          <Card.Body className="phone-modal__body">
            {/* Lock Icon */}
            <div className="text-center mb-3">
              <div className="phone-modal__icon-wrapper">
                <FiLock className="phone-modal__lock-icon" />
              </div>
            </div>

            {/* Title */}
            <h6 className="phone-modal__title">Add your phone number</h6>

            {/* Subtitle */}
            <p className="phone-modal__subtitle">
              Link your phone to secure your account
            </p>

            {/* Phone Input */}
            <Form onSubmit={handleGetOTP}>
              <Form.Group className="mb-4">
                <Form.Label className="phone-modal__form-label">
                  Enter your Phone number
                </Form.Label>

                <div className="input-group">
                  <Form.Select
                    className="phone-modal__country-select"
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                    disabled={sendOtpMutation.isLoading}
                  >
                    {countryList.map((country) => (
                      <option key={country.code} value={country.code}>
                        {country.code}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control
                    type="tel"
                    className="phone-modal__phone-input"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="Enter phone number"
                    disabled={sendOtpMutation.isLoading}
                    required
                  />
                </div>
              </Form.Group>

              {/* Buttons */}
              <div className="d-flex gap-2">
                <Button
                  variant="outline-secondary"
                  className="w-50"
                  onClick={handleCancel}
                  disabled={sendOtpMutation.isLoading}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className="w-50"
                  type="submit"
                  disabled={sendOtpMutation.isLoading || !phoneNumber.trim()}
                >
                  {sendOtpMutation.isLoading ? "Sending..." : "Get OTP"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default SendOtp;
